import { useProcessIdOnSingleProcessPage } from "components/CustomGridItems/LotInfoBar/lotInfoUtils";
import { CUSTOMERS_CUSTOM_DISPLAY_UNITS_MULTIPLIERS } from "constants/customers";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { getPnlFormattedHoursMinutes, ONE_MINUTE_OF_MS } from "utils/timeUtils";

export function HoursAndMinutes({ timeMs }: { timeMs?: number | null }) {
  const ckey = useCustomerKey();
  const processId = useProcessIdOnSingleProcessPage();
  const { hours, minutes } = getPnlFormattedHoursMinutes(timeMs);
  const totalMinutes = timeMs && timeMs / ONE_MINUTE_OF_MS;
  const customDisplayUnits =
    processId && CUSTOMERS_CUSTOM_DISPLAY_UNITS_MULTIPLIERS[ckey]?.[processId];
  return (
    <div className="hoursMinutes">
      {timeMs === null ? (
        <>
          <div className="hours" style={{ marginLeft: 6 }} />
          <div className="minutes" style={{ marginRight: 12 }}>
            --
          </div>
        </>
      ) : totalMinutes && customDisplayUnits ? (
        <>
          <div className={`hours`}>
            {Math.round(totalMinutes * customDisplayUnits.unitsPerMinute)}
            {customDisplayUnits.displayName}
          </div>
        </>
      ) : (
        <>
          <div className={`hours${hours === "0" ? " zero" : ""}`}>{hours}h</div>{" "}
          <div className={`minutes${minutes === "0" ? " zero" : ""}`}>
            {minutes}m
          </div>
        </>
      )}
    </div>
  );
}
